import { render, staticRenderFns } from "./ViewAndEdit.vue?vue&type=template&id=84e12b8c&scoped=true&"
import script from "./ViewAndEdit.vue?vue&type=script&lang=js&"
export * from "./ViewAndEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e12b8c",
  null
  
)

export default component.exports